import { getRequestPAdmin } from "common/HttpClient/http-utility";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";

const activeCustomersPath = INFRAMARK_CONSTANTS.groups.services.activeGroups;

let activeCustomersCache = null;
let activeCustomersInflight = null;

const extractActiveCustomersPayload = (responseData) => {
  if (Array.isArray(responseData)) {
    return responseData;
  }
  if (responseData && Array.isArray(responseData.data)) {
    return responseData.data;
  }
  return [];
};

//only place where we are mapping code to customerCode etc, in other places we use customerCode directly
const mapActiveCustomerRecord = (item) => {
  return {
    ...item,
    customerId: item.id,
    customerName: item.name,
    customerCode: item.code,
  };
};

const sortAndFilterActiveCustomers = (rawList) => {
  const filtered = (rawList ?? []).filter(
    (item) => item && item.isDeleted !== true
  );
  return [...filtered].sort((a, b) => {
    const idA = a.id ?? 0;
    const idB = b.id ?? 0;
    return Number(idA) - Number(idB) || String(idA).localeCompare(String(idB));
  });
};

const loadActiveCustomersFromApi = async () => {
  const response = await getRequestPAdmin(activeCustomersPath);
  if (response?.error) {
    return [];
  }
  const rawList = extractActiveCustomersPayload(response?.data);
  return sortAndFilterActiveCustomers(rawList).map(mapActiveCustomerRecord);
};

export async function fetchAppActiveCustomers() {
  if (activeCustomersCache) {
    return activeCustomersCache;
  }
  if (!activeCustomersInflight) {
    activeCustomersInflight = loadActiveCustomersFromApi()
      .then((list) => {
        activeCustomersCache = list;
        return list;
      })
      .finally(() => {
        activeCustomersInflight = null;
      });
  }
  return activeCustomersInflight;
}

export function getCachedAppActiveCustomers() {
  return activeCustomersCache;
}

export function resetAppActiveCustomersCache() {
  activeCustomersCache = null;
  activeCustomersInflight = null;
}
